module.exports = __webpack_public_path__ + "media/images/project/sort-72227aa2581f0facda6948dd60418d95.svg";